import React from 'react';
import { Form, FilterGrid, FilterField } from '@/components/ui';
import FiltersCard from '../../../components/FiltersCard';
import type { MessageBoardFeed } from '../hooks/useMessageBoardFeed';

export interface MessageBoardFiltersProps {
  feed: MessageBoardFeed;
}

const MessageBoardFilters: React.FC<MessageBoardFiltersProps> = ({ feed }) => {
  const {
    foremanAreas,
    defaultAreaId,
    foremanAreaId,
    setForemanAreaId,
    urgency,
    setUrgency,
    dateFrom,
    setDateFrom,
    dateTo,
    setDateTo,
    resetPage,
    clearFilters,
    hasExtraFilters,
    selectedAreaId,
  } = feed;

  if (foremanAreas.length === 0) return null;

  return (
    <FiltersCard
      title="Filters"
      subtitle="Foreman area, urgency, and date range"
      collapsible
      showClearButton
      onClear={clearFilters}
      hasActiveFilters={
        hasExtraFilters || (selectedAreaId != null && selectedAreaId !== defaultAreaId)
      }
    >
      <FilterGrid min="md">
        <FilterField>
          <Form.Group className="tw-mb-0" controlId="message-board-list-area">
            <Form.Label>Foreman area</Form.Label>
            <Form.Select
              value={foremanAreaId === '' ? '' : String(foremanAreaId)}
              onChange={(e) => {
                const v = e.target.value;
                setForemanAreaId(v === '' ? '' : Number(v));
                resetPage();
              }}
            >
              {foremanAreas.map((area) => (
                <option key={area.id} value={area.id}>
                  {area.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </FilterField>
        <FilterField>
          <Form.Group className="tw-mb-0" controlId="message-board-list-urgency">
            <Form.Label>Urgency</Form.Label>
            <Form.Select
              value={urgency}
              onChange={(e) => {
                const v = e.target.value;
                setUrgency(v === 'URGENT' || v === 'NORMAL' ? v : '');
                resetPage();
              }}
            >
              <option value="">All</option>
              <option value="NORMAL">Normal</option>
              <option value="URGENT">Urgent</option>
            </Form.Select>
          </Form.Group>
        </FilterField>
        <FilterField>
          <Form.Group className="tw-mb-0" controlId="message-board-list-from">
            <Form.Label>From</Form.Label>
            <Form.Control
              type="date"
              value={dateFrom}
              onChange={(e) => {
                setDateFrom(e.target.value);
                resetPage();
              }}
            />
          </Form.Group>
        </FilterField>
        <FilterField>
          <Form.Group className="tw-mb-0" controlId="message-board-list-to">
            <Form.Label>To</Form.Label>
            <Form.Control
              type="date"
              value={dateTo}
              onChange={(e) => {
                setDateTo(e.target.value);
                resetPage();
              }}
            />
          </Form.Group>
        </FilterField>
      </FilterGrid>
    </FiltersCard>
  );
};

export default MessageBoardFilters;
